import {ProjectsEndpoints } from "../../Routes/api/Endpoints";
import { ApiMananger } from "../../redux/libs/apiManager"


export const tachesApi = ApiMananger.injectEndpoints({ 
  endpoints: (build) => ({
    getTask: build.query({
      query: (projectId) => ({
        url: `${ProjectsEndpoints.getTaskByProjectId}${projectId}`,
        method: "GET",
      }),
      transformResponse: (response) => response,
      invalidatesTags: ["Taches", "Projects"],
    }),
    fetchProjects: build.query({
      query: () => ({
        url: ProjectsEndpoints.getProjects,
        method: "GET",
      }),
      transformResponse: (response) => response.projects,
      invalidatesTags: ["Projects"],
    }),
    putTache: build.mutation({
      query: ({ endpoint, elementID, formData }) => ({
        url: `${endpoint}${String(elementID)}`,
        method: "POST",
        body: formData,
      }),
      // invalidatesTags: ["Projects", "Notifications"],
    }),
    putCriteria: build.mutation({
      query: ({ endpoint, task }) => {
        return {
          url: `${endpoint}${task?.id}`,
          method: "PUT",
          body: task,
        };
      },
      async onQueryStarted({ endpoint, task, parentTaskId }, { dispatch, queryFulfilled }) {
        // Utiliser parentTaskId pour cibler la requête getCriteria
        const patchResult = dispatch(
          tachesApi.util.updateQueryData('getCriteria', { taskId: parentTaskId }, (draft) => {
            const microTask = draft?.microTaches?.find(t => t.id === task.id);
            if (microTask) {
              microTask.terminer = task?.terminer;
            }
          })
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (result, error, arg) => [
        { type: "Criteria", id: arg.parentTaskId },
        "Projects",
        "Criteria",
      ],
    }), 
    getCriteria: build.query({
      query: ({taskId}) => ({
        url: `${ProjectsEndpoints.getMicroTask}${taskId}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [{ type: "Criteria", id: arg.taskId }]
    }),
  }),
});

export const {
  useGetTaskQuery,
  useFetchProjectsQuery,
  usePutTacheMutation,
  useGetCriteriaQuery,
  usePutCriteriaMutation
} = tachesApi;

// export default tachesApi